import { connect } from 'react-redux';
import { fetchInventoryItemsAvailability } from '../../../redux/Inventory/sagas/item/routines';
import {
  getIsFetching as getIsFetchingItems,
  getIsFetched as getIsFetchedItems,
  getOrder
} from '../../../redux/Inventory/selectors/item/availability';
import {
  clearInventoryItemsAvailability,
  inventoryItemsAvailabilityOnChangePage,
  inventoryItemsAvailabilityOnChangeOrder
} from '../../../redux/Inventory/actions/item';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Inventory/selectors/item/availability-pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import { ItemType } from '../../../constants/inventory/InventoryTypes';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import AvailabilityList from '../../../components/inventory/AvailabilityList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(
    state,
    SEARCH_CONTEXT.ITEM_AVAILABILITY
  );
  const order = getOrder(state);

  return {
    type: ItemType,
    items: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetchingItems(state),
    isFetched: getIsFetchedItems(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchInventoryItemsAvailability(query));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchInventoryItemsAvailability(query));
      else dispatch(inventoryItemsAvailabilityOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryItemsAvailability());
      dispatch(fetchInventoryItemsAvailability(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearInventoryItemsAvailability());
      dispatch(fetchInventoryItemsAvailability({ ...query, order }));
      dispatch(inventoryItemsAvailabilityOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AvailabilityList);
